import { createQueryParams } from '@nexio/emvio-util-app';
import config from '../../config/config';
import { buildTableSuccessActionBasedOnCount } from '../../utils/actionCreators';
import { goToUrl } from '../Table/tableActions';

export const PAYOUT_BATCHES_LOAD = 'PAYOUT_BATCHES/PAYOUT_BATCH_LOAD';
export const PAYOUT_BATCHES_SUCCESS = 'PAYOUT_BATCHES/PAYOUT_BATCH_SUCCESS';
export const PAYOUT_BATCHES_FAILURE = 'PAYOUT_BATCHES/PAYOUT_BATCH_FAILURE';

export const PENDING_PAYOUT_BATCHES_LOAD = 'PAYOUT_BATCHES/PENDING_PAYOUT_BATCH_LOAD';
export const PENDING_PAYOUT_BATCHES_SUCCESS = 'PAYOUT_BATCHES/PENDING_PAYOUT_BATCH_SUCCESS';
export const PENDING_COUNT_LOAD = 'PAYOUT_BATCHES/PENDING_COUNT_LOAD';
export const PENDING_COUNT_SUCCESS = 'PAYOUT_BATCHES/PENDING_COUNT_SUCCESS';
export const PENDING_COUNT_FAILURE = 'PAYOUT_BATCHES/PENDING_COUNT_FAILURE';

export const fetchUrl = `${config.payoutApiUrl}/batch`;

export function selectPayoutBatch(history, payoutBatch, newTab) {
    goToUrl(history, `/payout-batch/${payoutBatch.id}`, newTab);
}

export function getPayoutBatches(filters, page, pageSize, sorters, payoutAccountIds, columns) {
    const batchFilters = {
        id: 'batchProcessingStatus',
        value: 'RUNNING,COMPLETE,CANCELED'
    };

    const queryParamsString = createQueryParams({
        dateKey: 'updatedAt',
        filters: [...filters, batchFilters],
        payoutAccountIds,
        page,
        pageSize,
        sorters,
        columns
    });

    return {
        failureActionTypeOrCreator: getPayoutBatchesFailureActionCreator,
        fetchParams: {
            url: `${fetchUrl}${queryParamsString}`
        },
        loadActionTypeOrCreator: PAYOUT_BATCHES_LOAD,
        successActionTypeOrCreator: getPayoutBatchesSuccessActionCreator
    };
}

export function getPayoutBatchesSuccessActionCreator(results) {
    return buildTableSuccessActionBasedOnCount(results, PAYOUT_BATCHES_SUCCESS, 'payoutBatches');
}

export function getPayoutBatchesFailureActionCreator(error) {
    return {
        error,
        type: PAYOUT_BATCHES_FAILURE
    };
}

export function getPendingPayoutBatches(filters, page, pageSize, sorters, payoutAccountIds, columns) {
    const queryParamsString = createQueryParams({
        dateKey: 'updatedAt',
        filters,
        payoutAccountIds,
        page,
        pageSize,
        sorters,
        columns
    });

    return {
        failureActionTypeOrCreator: getPayoutBatchesFailureActionCreator,
        fetchParams: {
            url: `${fetchUrl}${queryParamsString}&batchProcessingStatus=REVIEW,PENDING_REVIEW`
        },
        loadActionTypeOrCreator: PAYOUT_BATCHES_LOAD,
        successActionTypeOrCreator: getPendingPayoutBatchesSuccessActionCreator
    };
}

export function getPendingPayoutBatchesSuccessActionCreator(results) {
    return buildTableSuccessActionBasedOnCount(results, PENDING_PAYOUT_BATCHES_SUCCESS, 'payoutBatches');
}

export function getPendingCountSuccessActionCreator(results) {
    return {
        count: results.count,
        type: PENDING_COUNT_SUCCESS
    };
}

export function getPendingCountFailureActionCreator(error) {
    return {
        error,
        type: PENDING_COUNT_FAILURE
    };
}

export function getPendingCount(payoutAccountIds) {
    const filters = [
        {
            id: 'batchProcessingStatus',
            value: 'REVIEW'
        }
    ];

    const queryParamsString = createQueryParams({
        dateKey: 'updatedAt',
        filters,
        payoutAccountIds,
        page: 0,
        pageSize: 10
    });

    return {
        failureActionTypeOrCreator: getPendingCountFailureActionCreator,
        fetchParams: {
            url: `${fetchUrl}${queryParamsString}`
        },
        loadActionTypeOrCreator: PENDING_COUNT_LOAD,
        successActionTypeOrCreator: getPendingCountSuccessActionCreator
    };
}
